import css from 'styled-jsx/css'
import { colors, fontSizes, measurements } from 'theme'

export default css`
  .container-neximo-tabs {
    width: 100%;
  }
  .container-neximo-tabs :global(.react-tabs, .buttons-container) {
    max-width: ${measurements.containerSize};
  }
  .container-neximo-tabs :global(.buttons-container) {
    margin: 2.5rem 0;
  }
  .container-neximo-tabs :global(.react-tabs__tab-list li i) {
    font-size: 1rem !important;
    padding: 0 8px 0 0 !important;
  }
  .container-neximo-tabs :global(.react-tabs__tab-list li:last-child) {
    border-right: none;
  }
  .container-neximo-tabs :global(.react-tabs__tab-list li) {
    box-shadow: inset 0 -3px ${colors.secondary};
    padding: 1.5rem 1rem;
    list-style: none;
    position: relative;
    transition: 200ms ease all;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    min-width: auto;
    cursor: pointer;
  }
  .container-neximo-tabs :global(.react-tabs__tab-list li:hover) {
    box-shadow: inset 0 -3px ${colors.primary};
    color: ${colors.primary};
  }
  .container-neximo-tabs
    :global(.react-tabs__tab-list .react-tabs__tab--selected) {
    box-shadow: inset 0 -3px ${colors.primary};
  }
  .container-neximo-tabs :global(.react-tabs__tab--selected:before) {
    transition: 200ms ease all;
  }
  .container-neximo-tabs :global(.react-tabs__tab-list) {
    margin-bottom: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    /* overflow-y: auto; */
    flex: 1;

    box-shadow: inset 0px -3px ${colors.secondary};
    justify-content: flex-start;
  }

  .container-neximo-tabs :global(.react-tabs__tab-list li) {
    padding-left: 2rem;
    padding-right: 2rem;
    max-width: max-content;
  }

  .container-neximo-tabs :global(.react-tabs__tab--selected) {
    color: ${colors.primary};
  }

  .container-neximo-tabs.padding-default {
    padding: 0 1.5rem;
  }

  .container-neximo-tabs.tabs-bordered :global(ul.react-tabs__tab-list) {
    border-bottom: solid 1px ${colors.border};
    box-shadow: none;
  }
  .container-neximo-tabs.tabs-bordered :global(.react-tabs__tab-list li) {
    border-top: solid 1px ${colors.border};
    border-left: solid 1px ${colors.border};
    box-shadow: none;

    max-width: initial;
    padding-left: initial;
    padding-right: initial;
  }
  .container-neximo-tabs.tabs-bordered
    :global(.react-tabs__tab-list li:last-child) {
    border-right: solid 1px ${colors.border};
  }

  .container-neximo-tabs.tabs-bordered
    :global(.react-tabs__tab-list .react-tabs__tab--selected) {
    box-shadow: inset 0 -3px ${colors.primary};
  }

  .container-neximo-tabs.fit-tabs :global(ul.react-tabs__tab-list) {
    width: 100%;
    box-shadow: inset 0 -1px ${colors.border};
  }
  .container-neximo-tabs.fit-tabs :global(.react-tabs__tab-list li) {
    width: fit-content;
    max-width: fit-content;
    padding: 1rem 1.5rem;
    border: none;
  }
  .container-neximo-tabs.fit-tabs
    :global(.react-tabs__tab-list li:last-child) {
    border: none;
  }

  .container-neximo-tabs.fit-tabs
    :global(.react-tabs__tab-list .react-tabs__tab--selected) {
    box-shadow: inset 0 -3px ${colors.primary};
  }

  @media screen and (max-width: 992px) {
    .container-neximo-tabs {
      padding: 0.5rem;
    }
    .container-neximo-tabs :global(.react-tabs__tab-list li) {
      padding: 1rem;
      min-width: auto;
      font-size: ${fontSizes.small};
    }
    .container-neximo-tabs :global(.form-title-tab) {
      display: none;
    }
    .container-neximo-tabs :global(.react-tabs__tab-list) {
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media screen and (min-width: 1200px) {
    .container-neximo-tabs :global(.react-tabs),
    .container-neximo-tabs :global(.buttons-container) {
      max-width: ${measurements.containerLargeSize};
    }
  }
`
